import React, { useState, useEffect, useContext } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import { AuthUserContext } from '../Session';
import * as ROUTES from '../../constants/routes';
import './styles.css';
import '../AlertModal/styles.css';

const PaymentSuccessBase = ({ firebase }) => {
  const { agreementId } = useParams();
  const history = useHistory();
  const authUser = useContext(AuthUserContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!authUser || !agreementId) {
      setLoading(false);
      return;
    }

    const unsubscribe = firebase.db
      .collection('franchiseAgreements')
      .doc(agreementId)
      .onSnapshot(
        (doc) => {
          if (doc.exists) {
            const data = doc.data();
            if (data.userId !== authUser.uid && authUser.email !== 'jeethbuildcon@gmail.com') {
              setError('Unauthorized access');
            }
          } else {
            setError('Agreement not found');
          }
          setLoading(false);
        },
        (err) => {
          console.error('Error loading payment data:', err);
          setError('Failed to load payment information');
          setLoading(false);
        }
      );

    return () => unsubscribe();
  }, [authUser, agreementId, firebase]);

  const handleGoToDashboard = () => {
    history.push({
      pathname: ROUTES.DASHBOARD,
      search: '?view=franchise',
    });
  };

  if (loading) {
    return (
      <div className="payment-status-container">
        <div className="payment-status-loading">
          <div className="spinner"></div>
          <p>Verifying your payment...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert-modal-overlay">
        <div className="alert-modal-container">
          <div className="alert-modal-icon error">
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 9l-6 6m0-6l6 6" />
            </svg>
          </div>
          <h2 className="alert-modal-title">Error</h2>
          <p className="alert-modal-message">{error}</p>
          <button className="alert-modal-button" onClick={handleGoToDashboard}>
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="alert-modal-overlay">
      <div className="alert-modal-container">
        <div className="alert-modal-icon success">
          <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2 className="alert-modal-title">Successful</h2>
        <p className="alert-modal-message">Click proceed to go to the franchise dashboard.</p>
        <button className="alert-modal-button" onClick={handleGoToDashboard}>
          Proceed
        </button>
      </div>
    </div>
  );
};

export default withFirebase(PaymentSuccessBase);
